import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { API_URL } from "../../../helpers/app_url";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  CardHeader,

} from "reactstrap"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import EligibilitypagesMenu from "../menu/eligibilitypages-menu";
import LeadEligibilityBreadcrumb from "components/Common/LeadEligibilityBreadcrumb";
import SaveButton from "components/buttons/save";
import axios from "axios";
import img1 from "../../../assets/img/doc-1.png"
import img2 from "../../../assets/img/doc-2.png"
import img3 from "../../../assets/img/doc-3.png"
import SafeField from "helpers/SafeField";
class MortgageEligibility extends Component {
  constructor(props) {
    super(props)
    this.state = {

      isRight: false,
      questions: ""
    }


  }
  componentDidMount() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (!obj || !obj.resultData) return;  // Ensure authUser and resultData exist

    const token = obj.resultData.bearerToken;
    const userId = localStorage.getItem("userId");
    if (!userId) return;  // Ensure userId exists

    const str = "Bearer " + token;

    axios
      .get(API_URL + `QualificationQuestion/allagentQualificationSpecificQuestionAnswers?agentId=${userId}&question=Mortgage Status`, {
        headers: { Authorization: str },
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          const questions = res.data[0];

          if (questions && questions.answers) {
            // Helper function to safely find the answer and its scoringValue
            const findScoringValue = (answer) => {
              const foundAnswer = questions.answers.find((a) => a.answer === answer);
              return foundAnswer ? foundAnswer.scoringValue : null;  // Return null if answer is not found
            };

            // Setting the state with the questions and answer scoring values
            this.setState({
              questions: {
                id: questions.id,
                qualificationQuestionId: questions.qualificationQuestionId,
                weightage: questions.weightage,
                answers: questions.answers,
                approved: findScoringValue("Approved"),
                notapproved: findScoringValue("Not Approved"),
              },
            });
          }
        } else {
          console.warn("No questions found.");
        }
      })
      .catch((error) => {
        console.error("Error fetching questions:", error);
      });
  }

 handleSubmit = (values, { setSubmitting }) => {
  const userId = parseInt(localStorage.getItem("userId"));

  const getAnswerObj = (label, value) => {
    const answerObj = this.state.questions?.answers?.find((a) => a.answer === label);
    return {
      id: answerObj?.id || 0,
      agentId: userId,
      questionId: answerObj?.questionId || this.state.questions?.id || 0,
      answer: label,
      scoringType: 0,
      scoringValue: parseInt(value) || 0,
      isActive: true,
    };
  };

  const submissionData = {
    createQualificationBulkQuestionWithAnswersList: [
      {
        id: this.state.questions?.id || 0,
        agentId: userId,
        weightage: parseInt(values.weightage) || 0,
        question: "Mortgage Status",
        primaryScoringValue: 0,
        secondaryScoringValue: 0,
        otherScoringValue: 0,
        isActive: true,
        questionAnswers: [
          getAnswerObj("Approved", values.approved),
          getAnswerObj("Not Approved", values.notapproved),
        ],
      },
    ],
  };

  //

 
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj.resultData.bearerToken;
  const str = "Bearer " + token;

  toast.loading("Please wait...");
  axios.post(API_URL + `QualificationQuestion/AddUpdateQualificationBulkQuestionAnswers`, submissionData, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: str,
    },
  })
  .then(response => {
    toast.dismiss();
    if (response.data.success === true) {
      toast.success("Saved successfully");
    } else {
      toast.error("Some error");
    }
  })
  .catch(error => {
    toast.dismiss();
    toast.error("Error submitting form");
    console.error("Error submitting form:", error);
  })
  .finally(() => {
    setSubmitting(false);
  });
  
};

  render() {

    return (
      <React.Fragment>

        <ToastContainer autoClose={2000} />

        <div className="page-content project-page-content">
          <MetaTags>
            <title>Eligibility Questions | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 pe-0">


            <Row className="mb20 project-header">
              <Col xl="6">
                <LeadEligibilityBreadcrumb
                  title={this.props.t("Lead")}

                  breadcrumbItem={this.props.t("Eligibility Questions")}
                />

              </Col>

            </Row>
            <Row>


              <Col xl="12">

                <Card>
                  <CardBody>
                    <EligibilitypagesMenu />
                    <Row className="align-items-stretch">
                      <Col sm="5">
                        <Formik
                          enableReinitialize={true}
                          initialValues={{
                            weightage: this.state.questions.weightage || "",
                            approved: this.state.questions.approved || "",
                            notapproved: this.state.questions.notapproved || "",


                          }}
                          validationSchema={Yup.object().shape({
                            weightage: Yup.number().required("This is required").typeError("Enter valid number"),
                            approved: Yup.number().required("This is required").typeError("Enter valid number"),
                            notapproved: Yup.number().required("This is required").typeError("Enter valid number"),



                          })}

                          onSubmit={this.handleSubmit}
                        >
                          {({ errors, touched, values, handleChange, setFieldValue }) => (
                            <Form
                              className="needs-validation"
                            >
                              <Card className="border-brk mt-40">
                                <CardHeader>
                                  <CardTitle>Step 1 : How important is the mortgage status in the overall eligibility score.</CardTitle>

                                  <Row>

                                    <Col sm="2">
                                      <FormGroup className="mb-3">

                                        <SafeField
                                          name="weightage"
                                          className={
                                            "form-control" +
                                            (errors.weightage && touched.weightage ? " is-invalid" : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="weightage"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="10">

                                      (Assign a numerical value (1-100) to indicate how important “Decision stage” of the buyer in your overall lead evaluation. A higher value means higher importance.)

                                    </Col>
                                  </Row>
                                </CardHeader>
                              </Card>
                              <Card className="border-brk mt-40">
                                <CardHeader>
                                  <CardTitle>Step 2 : Assign scores for different decision timeframes</CardTitle>
                                  <p>(Assign a numerical value (1-100) to indicate how important “mortgage staus” of the buyer in your overall lead evaluation. A higher value means higher importance.)</p>
                                  <Row>
                                <Col md="3">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="approved">
                                      {this.props.t("Pre-approved")}
                                    </Label>

                                  </FormGroup>
                                </Col>
                                <Col md="2">
                                  <FormGroup className="mb-3">

                                    <SafeField
                                      name="approved"
                                      className={
                                        "form-control" +
                                        (errors.approved && touched.approved ? " is-invalid" : "")
                                      }
                                      onChange={handleChange}
                                      type="text"
                                    />

                                    <ErrorMessage
                                      name="approved"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col sm="7">
                                Leads who are already pre-approved for a mortgage
                                </Col>

                              </Row>
                              <Row>
                                <Col md="3">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="notapproved">
                                      {this.props.t("Not pre-approved")}
                                    </Label>

                                  </FormGroup>
                                </Col>
                                <Col md="2">
                                  <FormGroup className="mb-3">

                                    <SafeField
                                      name="notapproved"
                                      className={
                                        "form-control" +
                                        (errors.notapproved && touched.notapproved ? " is-invalid" : "")
                                      }
                                      onChange={handleChange}
                                      type="text"
                                    />

                                    <ErrorMessage
                                      name="notapproved"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col sm="7">Leads who are curently not pre-approved for a mortgage</Col>

                              </Row>
                              <SaveButton>Save</SaveButton>
                                </CardHeader>
                              </Card>             

                            </Form>
                          )}
                        </Formik>
                      </Col>
                      <Col sm="1" className="d-flex align-items-stretch justify-content-center">
                    <div className="vertical-line"></div>
                   </Col>

                   <Col sm="6">
                                              <div className="link-page">
                     
                      <div className="open-bg">
                        <h4><img src={img3} width="32px" /> Purpose</h4>
                         <ul className="no-list-type">
                              <li>A lead’s mortgage readiness can be a strong indicator of how close they are to making a purchase. Knowing whether a lead is pre-approved, in the process, or hasn’t started helps you prioritize and tailor your follow-up. </li>

                               <li><strong>Step 1: Set Importance Level</strong><br/>
                             Choose how much this factor should impact the total Lead Eligibility Score. If financing is a key part of your qualification process, you might assign it high importance. 
                               
                               </li>

                                <li><strong>Step 2: Assign Scores Based on Mortgage Stage</strong><br/>
                              Assign points to each mortgage stage based on how valuable or “ready” you believe that lead is. 

                               <br/>
                               <strong>For example:</strong> If you only work with pre-approved buyers, that option could get the highest score. 
                             
                               </li>
                            </ul>
                       
                        
                      </div>
                      
                 

                     
                        </div>
                                              </Col>
                    </Row>
                  
                  </CardBody>
                </Card>




              </Col>

            </Row>



          </Container>
        </div>
      </React.Fragment>
    )
  }
}
MortgageEligibility.propTypes = {
  t: PropTypes.any,



}
const mapStateToProps = ({ }) => (
  {



  })
const mapDispatchToProps = dispatch => ({



});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MortgageEligibility))
